import React from 'react';
import styled from '@emotion/styled';
import { StyledFlightDetailHighlight } from './StyledFlightDetailHighlight';

const Placeholder = styled.div<{}>`
	min-height: 300px;
`;

export const FlightDetailLoading = () => (
	<StyledFlightDetailHighlight>
		<Placeholder />
	</StyledFlightDetailHighlight>
);
